import axios from "axios";

export function getCategories() {
    let url = process.env.REACT_APP_BASE_URL + `api/v1/categories/all`;
    const bannerToken =localStorage.getItem("rfis");
    return axios.get(url, {
      headers: {
        rf_token_header123_k: bannerToken,
        "Content-Type": "application/json",
      },
    });
  }
  
  export function getCategory(id) {
    let url = process.env.REACT_APP_BASE_URL + `api/v1/categories/${id}`;
    const bannerToken =localStorage.getItem("rfis");
    return axios.get(url, {
      headers: {
        rf_token_header123_k: bannerToken,
        "Content-Type": "application/json",
      },
    });
  }
export function addCategory(data){
    const bannerToken =localStorage.getItem("rfis");
    return axios.post(process.env.REACT_APP_BASE_URL + `api/v1/categories`, data, {
        headers: {
            'rf_token_header123_k': bannerToken,
        
        }
    });
}
export function updateCategory(id,data){
    const bannerToken =localStorage.getItem("rfis");
    return axios.put(process.env.REACT_APP_BASE_URL + `api/v1/categories/${id}`, data, {
        headers: {
            'rf_token_header123_k': bannerToken,
        
        }
    });
}

export function deleteCategory(id) {
    const token =localStorage.getItem("rfis");
        return axios.delete(
          process.env.REACT_APP_BASE_URL + `api/v1/categories/${id}`,
          {
            headers: {
              rf_token_header123_k: token,
              "Content-Type": "application/json",
            },
          }
        ); 
      }

/**
 * Translate English category name into the other language fields via server-side Servam proxy.
 * @param {string} text English source text
 */
export function translateCategoryLanguages(text) {
  const token = localStorage.getItem("rfis");
  return axios.post(
    process.env.REACT_APP_BASE_URL + `api/v1/translate`,
    { text },
    {
      headers: {
        rf_token_header123_k: token,
        "Content-Type": "application/json",
      },
    }
  );
}
      
export const languages = [
  { id: 1, langCode: "en", name: "English", lang: "English" },
  { id: 2, langCode: "hi", name: "Hindi", lang: "हिंदी" },
  { id: 3, langCode: "ta", name: "Tamil", lang: "தமிழ்" },
  { id: 4, langCode: "gu", name: "Gujarati", lang: "ગુજરાતી" },
  { id: 5, langCode: "ben", name: "Bengali", lang: "বাংলা" },
  { id: 6, langCode: "ma", name: "Marathi", lang: "मराठी" },
  { id: 7, langCode: "kan", name: "Kannada", lang: "ಕನ್ನಡ" },
  { id: 8, langCode: "tel", name: "Telugu", lang: "తెలుగు" },
  { id: 9, langCode: "ori", name: "Odia", lang: "ଓଡିଆ" },
  { id: 10, langCode: "mal", name: "Malayalam", lang: "മലയാളം" },
  { id: 11, langCode: "pa", name: "Punjabi", lang: "ਪੰਜਾਬੀ" },
];
